import type { ComponentChildren } from 'preact';
import { Dropdown } from 'components/dropdown/Dropdown.tsx';
import { useMouseEnterWithClick } from 'utils/mouseEvent.ts';
import { cn } from 'utils/cn.tsx';
import { CommonPortalContainer } from 'components/dropdown/containers/CommonPortalContainer';

type Props = {
	openerContent: ComponentChildren;
	mobileTitle?: string;
	children: ComponentChildren;
	placement?: Dropdown.Placement;
	openerClassName?: string;
	containerClassName?: string;
	wrapperClassName?: string;
	dataTest?: string;
};

export function Tooltip({
	children,
	openerContent,
	placement = 'bottom-center',
	mobileTitle,
	openerClassName,
	containerClassName,
	wrapperClassName,
	dataTest,
}: Props) {
	return (
		<Dropdown
			renderOpener={({ toggleOpen, openerRef, open }) => (
				<button
					class={cn('flex', openerClassName)}
					ref={openerRef}
					{...useMouseEnterWithClick(open, toggleOpen)}
				>
					{openerContent}
				</button>
			)}
			renderContainer={(props: Dropdown.RenderContainerProps) => (
				<CommonPortalContainer {...props} mobileTitle={mobileTitle} className={containerClassName} />
			)}
			placement={placement}
			closeOnMouseLeave
			wrapperClassName={wrapperClassName}
			dataTest={dataTest}
		>
			{children}
		</Dropdown>
	);
}
